import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
export default axiosInstance;

export const getTopClubs = async () => {
  try {
    const response = await axiosInstance.get(
      `home/top-clubs?`,
    );
    return response.data;
    } catch (error) {
    console.error("Error fetching top clubs:", error);
    throw error;
  } 
};

export const getLeagueList = async () => {
  try {
    const response = await axiosInstance.get("frontend/league-list");
    return response.data;
  } catch (error) {
    console.error("Error fetching league list:", error);
    throw error;
  }
};

export const getRegionList = async () => {
  try {
    const response = await axiosInstance.get("frontend/regions-list");
    return response.data;
  } catch (error) {
    console.error("Error fetching region list:", error);
    throw error;
  } 
};
export const getClubList = async () => {
  try {
    const response = await axiosInstance.get("frontend/clubs-list");
    return response.data;
  } catch (error) {
    console.error("Error fetching club list:", error);
    throw error;
  }
};
export const getLeagueTable = async (
  country: string,
  league: string,
  club: string,
  page: number,
) => {
  try {
    const formBody = new URLSearchParams();
    formBody.append("region", country || "");
    formBody.append("league_name", league || "");
    formBody.append("club", club || "");
    formBody.append("page", String(page));
    formBody.append("per_page", "100");

    const response = await axiosInstance.post(
      "frontend/league-table",
      formBody,
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching league table:", error);
    throw error;
  }
};

export const getClubAnalytics = async (
  clubIds: string,
) => {
  try {
    const response = await axiosInstance.get(`frontend/analytics/compare?club_ids=${clubIds}`, );
    return response.data;
  } catch (error) {
    console.error("Error fetching analytic data:", error);
    throw error;
  }
};

export const getClubLists = async (
  region: string,
  league: string,
  page: number,
) => {
  try {
    const response = await axiosInstance.get(
      `frontend/clubs/profiles?region=${region}&league=${league}&page=${page}&per_page=18`,
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching club details:", error);
    throw error;
  } 
};

export const getClubDetails = async (clubId: string) => {
  try {
    const response = await axiosInstance.get(`frontend/clubs/profile/${clubId}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching club details:", error);
    throw error;
  }
};

export const refershTitenIndex = async () => {
  try {
    const response = await axiosInstance.get(`update-titan-index`);
    return response.data;
  } catch (error) {
    console.error("Error fetching club details:", error);
    throw error;
  }
};
